import React, { useEffect, useRef, useState } from 'react';
import { Grid, Autocomplete, Typography, TextField} from '@mui/material';
import { connect } from 'react-redux';
import * as menuActions from '../../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import DefaultTable from '../../components/Table';
import TableCell from '@mui/material/TableCell';
import appConfig from "../../config/appConfig";
import SkeletonGridLoader from '../../components/SkeletonGridLoader';
import RemoveDialog from '../../components/RemoveDialog';
import * as charityActions from '../../store/actions/charitableActivity';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/Download';
import { MultiSelect } from "react-multi-select-component";
import FormControl from '@mui/material/FormControl';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useLogout } from '../../components/Utils';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useTranslation } from 'react-i18next';
import FilterListIcon from '@mui/icons-material/FilterList';


const dropDownlistCss = { mt: 1, mb: 1, borderRadius: "5px", border: `1px solid ${appConfig.colors.darkblue}`, background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px" } };
const datePropDownCss = { mt: 1, mb: 1, borderRadius: "5px", background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px", outline: "none" } };
const gridItemCss = { '&.MuiGrid-item': { pt: 0, pl: 2, pr: 2} };

const mb = { marginBottom: 0, fontWeight: "bold", color: appConfig.colors.darkgray };

const CharitableActivity = ({setBreadcrumb, fetchCharityList, charityActivity, deleteCharitableActivity, deletedCharity, getBUnitFilterDetails, bunitFilterList, exportReport}) => {
  const { t } = useTranslation('common');
  const sessionFilter = JSON.parse(window.sessionStorage.getItem("filterValuesCharity"));

  const navigate = useNavigate();
  const onLogout = useLogout();

  const isMounted = useRef(false);
  const params = useLocation();

  const [isFilterOpen, setIsFilterOpen] = useState(sessionFilter?.isFilterOpen || false);

  const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  const [filterList, setFilterList] = useState([]);
  const [fromDate, setFromDate] = useState(sessionFilter?.startDate ? new Date(`${sessionFilter?.startDate}T00:00:00`) : null);
  const [toDate, setToDate] = useState(sessionFilter?.endDate ? new Date(`${sessionFilter?.endDate}T00:00:00`) : null);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState(sessionFilter?.filterByBusinessUnit || []);
  const [selectedLocationNames, setSelectedLocationNames] = useState(sessionFilter?.filterByBusinessUnitLocation || []);
  const [charityName, setCharityName] = useState(sessionFilter?.charityName || '');
  const [activityName, setActivityName] = useState(sessionFilter?.activityName || '');
  const [filterValues, setFilterValues] = useState(null);

  const getSelectedLocations = () => {
    return filterList.flatMap(item => item?.businessLocation?.map((location) => ({
      "locationId": location?.id,
      "locationName": location?.locationName
    })));
  };

  const updateLocationOptions = () => {
    const locations = getSelectedLocations();
    const locationOptions = [...new Set(locations)]?.map((item) => ({
      label: item?.locationName,
      value: item?.locationId,
    })).sort((a, b) => a?.label?.localeCompare(b.label));;
    const businessUnitOptions = filterList?.map((businessUnit) => ({
      label: businessUnit?.businessUnitName,
      value: businessUnit?.businessUnitId,
    }));
    return locationOptions;
  };
  const handleToggle = () => {
    setIsFilterOpen(!isFilterOpen); // Toggle between true and false
  };


  // const businessUnitOptions = filterList?.map((businessUnit) => ({
  //   label: businessUnit.businessUnitName,
  //   value: businessUnit.businessUnitId,
  // }));
  const businessUnitOptions = filterList
  ?.map((businessUnit) => ({
    label: businessUnit.businessUnitName,
    value: businessUnit.businessUnitId,
  }))
  .sort((a, b) => a?.label?.localeCompare(b.label));

  const defaultFilter = businessUnitOptions?.map(item => item.value);

  const handleBusinessUnitChange = (selectedOptions) => {
    setSelectedBusinessUnits(selectedOptions);
    // setSelectedLocationNames([]);
  };

  const locationOptions = updateLocationOptions();

  const handleLocationChange = (selectedOptions) => {
    setSelectedLocationNames(selectedOptions);
  };
  const handleCharityNameChange = (text) => {
    setCharityName(text?.target?.value);
  };
  const handleActivityNameChange = (text) => {
    setActivityName(text?.target?.value);
  };

  const { handleSubmit } = useForm();

  useEffect(()=>{
    getBUnitFilterDetails();
  },[])
  const defaultFilterLoc = filterList
  ?.flatMap(item => item?.businessLocation?.filter(location => location?.isSelected) || [])
  ?.map(location => ({
    value: location?.id,
    label: location?.locationName,
  }));
  useEffect(()=>{
  if(bunitFilterList && bunitFilterList?.status === 200){
    const dataArr = bunitFilterList?.data || []
    setFilterList(dataArr);
    const defaultFilter = dataArr?.map((businessUnit) => ({
      label: businessUnit?.businessUnitName,
      value: businessUnit?.businessUnitId,
    }));
    
    setSelectedBusinessUnits(sessionFilter?.filterByBusinessUnit || defaultFilter)
    setSelectedLocationNames(sessionFilter?.filterByBusinessUnitLocation || defaultFilterLoc)

    const selectedBusinessUnitsNew = sessionFilter?.filterByBusinessUnit || selectedBusinessUnits
    const filterValues1 = {
      filterByBusinessUnit: selectedBusinessUnitsNew.length === businessUnitOptions.length ? [] : selectedBusinessUnitsNew || businessUnitOptions?.map(item => item.value),
      filterByBusinessUnitLocation: defaultFilterLoc,
      charityName: charityName,
      activityName: activityName,
      startDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
      endDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
      businessId : selectedBusinessUnitsNew?.map(item => item.value) || businessUnitOptions?.map(item => item.value),
    }
    setFilterValues(sessionFilter || filterValues1)
    if(defaultFilterLoc.length) {
      fetchCharityList(pagination.limit, pagination.offset, sessionFilter || filterValues1);
    }
  } else if(bunitFilterList && bunitFilterList?.status === 401){ 
    onLogout();
  }
  },[bunitFilterList, filterList])

  const filterInitialState = {
      locations: [],
      templates: [],
      startDate: '',
      endDate: ''
  }
  const [filterData, setFilterData] = useState(filterInitialState);

  const [pagination, setPagination] = useState({ limit: sessionFilter?.pagination?.limit || 10, offset: sessionFilter?.pagination?.offset || 1 });
  const [businessUnitFilter, setBusinessUnitFilter] = useState(params?.state && params?.state?.dropdownSelected ? params?.state?.dropdownSelected : { key: 'All', value: "all" });
  const [selected, setSelected] = useState(null);
  const [sortValue, setSortValue] = useState({sortBy:"modifiedTime", sortOrder: "desc"});
  const [searchText, setSearchText] = useState("");
  const [selectedBusinessUnit,setSelectedBusinessUnit] = useState({});
  const [charityListDetails, setCharityListDetails] = useState([]);



  const handleDialogOpen = (card) => {
    setRemoveDialogOpen(true);
  };
  const handleDialogClose = () => {
    setRemoveDialogOpen(false);
  };
  const onDeleteAction = () => {
    const data = {
      "id":selectedBusinessUnit.id
    }
    setIsLoading(true);
    deleteCharitableActivity(data); 
  }

useEffect(() => {
  setBreadcrumb(t('Charitable Activities'))
  if (params.state && params.state.dropdownSelected) {
    setBusinessUnitFilter(params.state.dropdownSelected);
  }
}, [params]);
const handlePagination = (limit, offset) => {
  const data1 = JSON.parse(window.sessionStorage.getItem('filterValuesCharity'));
  if (data1 && data1.pagination) {
    data1.pagination.limit = limit; // Set your new limit value
    data1.pagination.offset = offset;
    window.sessionStorage.setItem('filterValuesCharity', JSON.stringify(data1));
  } else {
    const data2 = {
      pagination: {
          limit: limit,  // Default limit value
          offset: offset   // Default offset value
      }
    };
    window.sessionStorage.setItem('filterValuesCharity', JSON.stringify(data2));
  }
  setPagination({ limit, offset })
}

useEffect(()=> {
  if(deletedCharity && deletedCharity.status === 200) {
    setIsLoading(false);
    handleDialogClose();
    fetchCharityList(pagination.limit, pagination.offset, filterValues);
  } else if(deletedCharity && deletedCharity.status === 401) {
    onLogout();
  }
},[deletedCharity])


useEffect(() => {
  isMounted.current = true;
  fetchCharityList(pagination.limit, pagination.offset, filterValues);
}, [JSON.stringify(pagination), businessUnitFilter,JSON.stringify(sortValue)])

// useEffect(() => {
//   if (!isMounted.current) {
//   setPagination({ limit: pagination.limit, offset: 1 })
//   fetchCharityList(pagination.limit, pagination.offset, filterValues, searchText);
// }
// }, [searchText])

  useEffect(()=>{
      if(charityActivity && charityActivity?.charityActivity && charityActivity?.charityActivity?.status === 200){
        const data = charityActivity?.charityActivity;
        setCharityListDetails({data:data})
      } else if (charityActivity && charityActivity?.status === 401) {
        onLogout();
      }
  },[charityActivity])

const renderCells = (row) => {
  const employeeFund = row.employeeFund ?  new Intl.NumberFormat().format(row.employeeFund) : 0.00
  const totalFund = row.totalAmount ? new Intl.NumberFormat().format(row.totalAmount) : 0.00
  return <>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.eventStartDate ? moment(row.eventStartDate).format('MM/DD/YYYY') : '-'}</TableCell>
    {/* <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.eventEndDate ? moment(row.eventEndDate).format('MM/DD/YYYYY') : '-'}</TableCell> */}
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.businessUnitName ? row.businessUnitName : '-'}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.businessUnitLocationName ? row.businessUnitLocationName : '-'}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.charityName ? row.charityName : "-"}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.eventName ? row.eventName : "-"}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, textAlign: 'right' }}><span style={{color: "#F57D4F", textTransform: 'uppercase'}}>{row?.currency || "CAD"} &nbsp;</span>{ totalFund }</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, textAlign: 'right' }}><span style={{color: "#F57D4F", textTransform: 'uppercase'}}>{row?.currency || "CAD"} &nbsp;</span>{employeeFund}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, textAlign: 'right' }}>{row.volunteerHours ? row.volunteerHours : "-"}</TableCell>
  </>
}

const renderActionButton = (row) => {
  return <div className='display-flex' style={{gap: 10, display: 'flex'}}>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={() => {navigate('/view-charitable-activity/'+row.id,{ state: { charity: row } })}}
              title={t('View')} aria-label="delete" size="small">
             <VisibilityIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          {row.isEditable === false ? (
            <>
            <IconButton sx={{ border: `1px solid ${appConfig.colors.lightGray}`, padding: '2px', cursor: 'default' }}
              title={t('Edit')} aria-label="Edit" size="small">
              <EditIcon sx={{ fontSize: 15, borderRadius: "50%", color: appConfig.colors.lightGray }} />
            </IconButton>
            <IconButton sx={{ border: `1px solid ${appConfig.colors.lightGray}`, padding: '2px', cursor: 'default' }}
              title={t('Delete')} aria-label="Delete" size="small">
              <DeleteIcon sx={{ fontSize: 15, borderRadius: "50%", color: appConfig.colors.lightGray }} />
            </IconButton>
            </>
          ) : 
            <>
            <IconButton sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px' }} onClick={() => { navigate('/edit-charitable-activity/' + row.id, { state: { charity: row } }); } }
              title={t('Edit')} aria-label="delete" size="small">
              <EditIcon sx={{ fontSize: 15, borderRadius: "50%", color: appConfig.colors.darkblue }} />
            </IconButton>
            <IconButton sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px' }} onClick={() => { setSelectedBusinessUnit(row); handleDialogOpen(row); } }
              title={t('Delete')} aria-label="delete" size="small">
                <DeleteIcon sx={{ fontSize: 15, borderRadius: "50%", color: appConfig.colors.darkblue }} />
            </IconButton>
            </>
          }
         
  </div>
}

const handleSort = (value) => {
  setSortValue(value)
}

const onSubmit = () => {

  const filterValues2 = {
    filterByBusinessUnit: selectedBusinessUnits.length === businessUnitOptions.length ? [] : selectedBusinessUnits || businessUnitOptions?.map(item => item.value),
    filterByBusinessUnitLocation: selectedLocationNames || "",
    charityName: charityName,
    activityName: activityName,
    startDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
    endDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
    businessId : selectedBusinessUnits?.map(item => item.value) || businessUnitOptions?.map(item => item.value),
    pagination: { limit: 10, offset: 1 },
    isFilterOpen: isFilterOpen
  }
  setFilterValues(filterValues2)
  sessionStorage.setItem("filterValuesCharity", JSON.stringify(filterValues2))
  setPagination({ limit: 10, offset: 1 })
  fetchCharityList(10, 1, filterValues2);
};
const onClear = () => {
  const defaultFilterLoc = filterList
    ?.flatMap(item => item?.businessLocation?.filter(location => location?.isSelected) || [])
    ?.map(location => ({
      value: location?.id,
      label: location?.locationName,
    }));
    const defaultFilter = filterList?.map((businessUnit) => ({
      label: businessUnit?.businessUnitName,
      value: businessUnit?.businessUnitId,
    }));
  const filterInitValues = {
      startDate: '',
      endDate: '',
      filterByBusinessUnit: defaultFilter,
      filterByBusinessUnitLocation: defaultFilterLoc,
      charityName: '',
      activityName: '',
      businessId :  businessUnitOptions?.map(item => item.value),
      location : selectedLocationNames?.map(item => item.value) || '',
    }
  setSelectedBusinessUnits(defaultFilter)
  setSelectedLocationNames(defaultFilterLoc)
  setFilterData(filterInitialState);
  setActivityName('');
  sessionStorage.removeItem("filterValuesCharity")
  setCharityName('');
  setPagination({ limit: 10, offset: 1 });
  setFromDate('');
  setToDate('');
  setSelected(null);
  setFilterValues(filterInitValues)
  fetchCharityList(10, 1, filterInitValues, searchText);
}

const handleExport = () => {
  const translatedHeadings = {
    "Activity Date": t("Activity Date"),
    "Business Unit": t("Business Unit"),
    "Location": t("Location"),
    "Charity Name": t("Charity Name"),
    "Activity Name": t("Activity Name"),
    "Martinrea Funds": t("Martinrea Funds"),
    "Employee Funds": t("Employee Funds"),
    "Volunteer Hours": t("Volunteer Hours"),
    "Export Date": t("Export Date"),
    "Total Records": t("Total Records") 
  };
  exportReport(filterValues, translatedHeadings)
}
  return (
    <div  style={{paddingRight: 10}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading' ><b>{t("Charitable Activities")}</b></h1>
        </Grid>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6} sx={{textAlign: {xs:"left", sm:"right", lg:"right", xl:"right",md:"right"}}}>
            <div>
              <Styled.CancelButton
                variant="outlined"
                style={{marginRight: 10}}
                className="xs-bold"
                onClick={handleExport}
              >
                <DownloadIcon sx={{fontSize: 15, borderRadius:"50%", marginRight: '5px'}} /> {t("Export")}
              </Styled.CancelButton>
              <Styled.PrimaryButton
                variant="contained"
                className="xs-bold"
                onClick={() => navigate('/create-charitable-activity', { state: { initState: true } })}
              >
                {t("Create")}
              </Styled.PrimaryButton>
               <div onClick={handleToggle} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', float: 'right', marginBottom: 10, fontFamily: appConfig?.fontfamily }}>
                    <IconButton>
                    <FilterListIcon style={{ color: '#000' }}  />
                    </IconButton>
                    <b>{isFilterOpen ? t('hideFilters') : t('showFilters')}</b>
                </div>
            </div>
        </Grid>
      </Grid>
      <hr className='blue-border mb-30' />
      {removeDialogOpen && (
          <RemoveDialog 
          openDialog={removeDialogOpen}
          onClose={handleDialogClose}
          isLoading={isLoading}
          cardContent={t("Are you sure want to delete?")}
          onSave={onDeleteAction}
          />
      )}
      <div className='filter-container'>
            {isFilterOpen && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} style={{alignItems: 'flex-end'}}>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By Business Units")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={businessUnitOptions}
                                  value={selectedBusinessUnits || defaultFilter}
                                  onChange={handleBusinessUnitChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>

                            <p style={mb}>{t("By Business Locations")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={locationOptions}
                                  value={selectedLocationNames}
                                  onChange={handleLocationChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By Charity Name")}</p>
                            <FormControl className='default-search' sx={dropDownlistCss}>
                              <OutlinedInput 
                                style={{height: 38, boxSizing: 'border-box'}} 
                                onChange={handleCharityNameChange} 
                                value={charityName}
                                placeholder={t("Search")} />
                            </FormControl>
                        </Grid>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By Activity Name")}</p>
                            <FormControl className='default-search' sx={dropDownlistCss}>
                              <OutlinedInput 
                                style={{height: 38, boxSizing: 'border-box'}} 
                                value={activityName}
                                onChange={handleActivityNameChange}  
                                placeholder={t("Search")} />
                            </FormControl>
                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>

                            <p style={mb}>{t("From Date")}</p>
                            
                            <FormControl sx={datePropDownCss} style={{height: 41}}>
                            <DatePicker
                                    // {...field}
                                    // sx={textboxCss}
                                    style={{marginBottom:0,  height: 40}}
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                    className='input-text-box1 mt-0' 
                                    onChange={(date) => setFromDate(date)} 
                                    value={fromDate}
                                />
                            </FormControl>
                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("To Date")}</p>
                            <FormControl sx={datePropDownCss}>
                            <DatePicker
                                    className='input-text-box1 mt-0' 
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                    onChange={(date) => setToDate(date)} 
                                    value={toDate}
                                />
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">
                                <Styled.PrimaryButton type="submit">
                                    {t("Apply")}
                                </Styled.PrimaryButton>

                            </FormControl>
                        </Grid>

                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                            style={{paddingLeft: "10px"}}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">

                                <Styled.CancelButton  sx={{padding:'5px'}} onClick={() => { onClear() }} >
                                    {t("Clear")} 
                                </Styled.CancelButton>
                            </FormControl>
                        </Grid>
                        

                    </Grid>
                </form>
            )} 
            </div>
            {/* <Grid
              item
              xs={12} lg={2.5} md={8} xl={2.5}
              sx={gridItemCss}
              style={{display:'flex',alignItems:'end', flexDirection: 'column',paddingRight: 0, maxWidth: '100%'}}
              id="charityTable"
          >
              <p style={mb}></p>
              <div style={{position: 'relative', top: '-8px'}} className='search-table'> 
              <TextField
                  placeholder={"Charity and Activity name"} value={searchText} 
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }} sx={
                    {
                      '& .MuiInputBase-input': {
                        backgroundColor: '#fcfcfb',
                        fontSize: 14,
                        padding: "7px",
                        paddingLeft: "15px",
                        height: "38px",
                        minWidth: 'unset',
                        border: "1px solid #005974",
                        borderRadius: "5px 0 0 5px",
                        outline: "none",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        boxSizing: 'border-box'
                      }
                    }
                  }
                />
                  {searchText?.length > 0 ? <ClearIcon onClick={()=>{handleSearch('');}} fontSize="small" sx={{ position: 'absolute', right: 80, top: 8, color: appConfig.colors.blueprimary }} /> : null}

                  <Styled.CancelButton
                    style={{ ...SearchButtonStyle }}
                    variant="contained"
                    onClick={() => handleSearch(searchText.trim())}
                  >
                    <SearchIcon />
                  </Styled.CancelButton>
                </div> 
          </Grid> */}
      { charityActivity?.isLoading ? <SkeletonGridLoader />
        :
      <DefaultTable
          title={t("Charitable Activities")}
          handlePagination={handlePagination}
          headers={[{name: t('Activity Date'), sortEnabled:false},{name: t('Business Unit'), sortEnabled:false}, {name: t('Location'), sortEnabled:false} ,{name: t('Charity Name'), sortEnabled:false},{name: t('Activity Name'), sortEnabled:false},{name: t('Martinrea Funds'), sortEnabled:false},{name: t('Employee Funds'), sortEnabled:false},{name: t('Volunteer Hours'), sortEnabled:false}]}
          data={charityActivity?.charityActivity}
          totalCount={charityActivity?.count}
          currentPage={pagination?.offset}
          currentLimit={pagination?.limit}
          rightHeaderIndex={[5,6,7]}
          defaultFilter={businessUnitFilter}
          selected={selected}
          renderCustomCells
          renderCells={renderCells}
          isFilterOpen={isFilterOpen}
          // searchCallback={(text) => handleSearch(text)}
          // searchPlaceholderText="Search"
          hasAction 
          renderActionButton={renderActionButton}
          isSortEnabled
        />
  }
      </div>
  );
}

const mapStateToProps = (state) => ({ 
  charityActivity: state.charitableActivity.charityActivity,
  deletedCharity: state.charitableActivity.deletedCharity,
  bunitFilterList: state.charitableActivity.bunitFilterList,
  })

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
        fetchCharityList: (limit, offset, filter, search) => dispatch(charityActions.getCharitableActivityList(limit, offset, filter, search)),
        deleteCharitableActivity: (id) => dispatch(charityActions.deleteCharitableActivity(id)),
        getBUnitFilterDetails: () => dispatch(charityActions.getBUnitFilterDetails()),
        exportReport: (data,translatedHeadings)=>dispatch(charityActions.exportReport(data,translatedHeadings))
    };
};
CharitableActivity.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    fetchCharityList: PropTypes.func.isRequired,
    charityActivity: PropTypes.object.isRequired,
    getBUnitFilterDetails: PropTypes.func.isRequired,
    deleteCharitableActivity: PropTypes.func.isRequired,
    exportReport:PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(CharitableActivity);

